<div class="flex rel">
  <!-- Toolbar Content -->
  <div #toolbarWrapper class="toolbar-wrapper flex-nosize">
    <ng-content select="[toolbar]" style="padding-right: 10px"></ng-content>
    <!-- <ng-container *NgTemplateOutlet=""></ng-container> -->
  </div>

  <!-- Main Content -->
  <div class="pa fill">
    <rx-scrollable (scrollNearEnd)="onScrollNearEnd()" [loading]="loadingMore">
      <mat-accordion class="flex" [ngStyle]="{ 'padding-top': toolbarHeight + 'px' }" displayMode="flat">
        <ng-content></ng-content>
      </mat-accordion>
    </rx-scrollable>

    <div class="load-more" *ngIf="loadingMore">
      <div class="spinner" *ngIf="!(ready | async)">
        <div class="spinner__content">
          <rx-icon name="icon-spinner"></rx-icon>
        </div>
        <div class="spinner__backdrop"></div>
      </div>
    </div>
  </div>

  <div class="overlay-container" [ngStyle]="{ top: toolbarHeight + 'px' }">
    <ng-content select="[overlay]"></ng-content>
  </div>
</div>
